export const VideoSessionStatus = {
	PENDING: "pending",
	ACTIVE: "active",
	ENDED: "ended",
} as const;
export type VideoSessionStatus = (typeof VideoSessionStatus)[keyof typeof VideoSessionStatus];

export const VideoEntityType = {
	MEETING: "meeting",
	EVENT: "event",
} as const;
export type VideoEntityType = (typeof VideoEntityType)[keyof typeof VideoEntityType];

export const UploadContextType = {
	USER_AVATAR: "user_avatar",
	COMMUNITY_AVATAR: "community_avatar",
	COMMUNITY_COVER: "community_cover",
	POST_MEDIA: "post_media",
	EVENT_COVER: "event_cover",
	MEETING_COVER: "meeting_cover",
	SPONSORED_MEDIA: "sponsored_media",
	COMMUNITY_MOBILE_APP_ICON: "community_mobile_app_icon",
	COMMUNITY_MOBILE_APP_SPLASH: "community_mobile_app_splash",
	COMMUNITY_MOBILE_APP_ADAPTIVE_ICON: "community_mobile_app_adaptive_icon",
} as const;
export type UploadContextType = (typeof UploadContextType)[keyof typeof UploadContextType];

export const RealtimeKitRecordingStatus = {
	UPLOADED: "UPLOADED",
	RECORDING: "RECORDING",
	FAILED: "FAILED",
	UPLOAD_FAILED: "UPLOAD_FAILED",
} as const;
export type RealtimeKitRecordingStatus = (typeof RealtimeKitRecordingStatus)[keyof typeof RealtimeKitRecordingStatus];
